import React, { Component } from 'react'
import io from '../../utils/socket-client';
import Modal from 'react-modal';
import GroupAccessItem from "./GroupAccessItem";
import {generateRandomString} from '../../utils/utils';
import UserGrid from './UserGrid';

export default class UserGridContainer extends Component {

    constructor(props){
        super(props);
        this.state = {
            modalIsOpen: false,
            changeGroupModalIsOpen: false,
            linkModalIsOpen: false,
            password: '',
            groupAccessItems: [],
            link: ''
        };
    }

    componentDidMount(){
        this.grid = this.refs.grid.refs.grid;
        this.gridData = this.refs.grid.source.localdata;
    }

    openNewUserModal() {
        this.setState({modalIsOpen: true, password: generateRandomString(6, false)});
    }

    openNewChangeGroupAccessModal(){
        this.setState({changeGroupModalIsOpen: true});
    }

    openNewLinkModal(token){
        this.setState({linkModalIsOpen: true, link: 'https://adspromote.ru?code=' + token});
    }

    closeModal() {
        this.props.clearError();
        this.setState({
            modalIsOpen: false,
            changeGroupModalIsOpen: false,
            linkModalIsOpen: false});
    }

    addUser(event){
        event.preventDefault();
        let login = this.refs.login.value;
        let userName = this.refs.userName.value;
        let password = this.refs.password.value;
        let localeType = this.refs.type.value;
        let type = this.props.typeMap.localeToOrigin[localeType];
        if(type === 'promoter' && !login.match(/^[0-9]{10}$/)){
            this.props.setError('Логин должен содержать только 10 цифр!');
            return false;
        }
        let newUser = {
            login,
            password,
            userName,
            groupAccess: [],
            type
        };
        io.sendChange({
            uri:io.USER_URI,
            operation: io.OPERATION_CREATE,
            data: newUser,
            success: () => {
                newUser.localeType = localeType;
                this.props.addUser(login, userName, type);
                this.grid.addrow(null, newUser);
                this.gridData.push(newUser);
                this.closeModal();
            }
        });
    }

    openChangeGroupAccess(datarow, idRow){
        this.datarow = datarow;
        this.idRow = idRow;
        let groupAccess = datarow.groupAccess || [];
        let groupAccessItems = [];
        this.props.groupNameList.forEach((item, index) => {
            let checked = false;
            if(groupAccess.indexOf(item) !== -1){
                checked = true;
                this.props.onAddGroupAccess(item);
            }
            groupAccessItems.push(
                <GroupAccessItem
                    checked={checked}
                    groupName={item}
                    key={index}
                    onAddGroupAccess={this.props.onAddGroupAccess}
                    onRemoveGroupAccess={this.props.onRemoveGroupAccess}/>)
        });
        this.setState({groupAccessItems: groupAccessItems});
        this.openNewChangeGroupAccessModal();
    }

    changeGroupAccess(){
        let checkedGroups = this.props.checkedGroupAccess;
        let sourceRow = this.datarow;
        let rowid = this.grid.getrowid(this.idRow);
        io.sendChange({
            uri: io.USER_URI,
            id: {login: sourceRow.login},
            data: {groupAccess: checkedGroups},
            operation: io.OPERATION_MODIFY,
            success: () => {
                sourceRow.groupAccess = checkedGroups;
                this.grid.updaterow(rowid, sourceRow);
                this.props.onClearGroupAccess();
                this.closeModal();
            },
            fail: () => this.props.setError('Не удалось изменить список. Попробуйте снова!')
        })
    }

    copyContent(){
        this.refs.referenceTextArea.select();
        let success = document.execCommand('copy');
        if(success){
            this.closeModal();
        } else {
            this.props.setError('Не удалось скопировать ссылку!');
        }
    }

    render() {
        let loginList = [];
        if(this.props.users) {
            this.props.users.forEach((item) => {
                loginList.push(item.login);
            });
        }

        const customStyles = {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)'
            },
            overlay: {
                zIndex: 100,
            }
        };

        let typeOptions = [];
        if(this.props.typeMap) {
            let id = 1;
            let map = this.props.typeMap.originToLocale;
            for(let key in map){
                typeOptions.push(<option key={id++} value={map[key]}>{map[key]}</option>);
            }
        }
        return (
            <div style={{display: 'flex', width: '100%', height: '100%', flexDirection: 'column', overflow: 'hidden'}}>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closeModal.bind(this)}
                        style={customStyles}
                        ariaHideApp={false}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Добавить пользователя">

                        <form style={{display: 'flex', flexDirection: 'column'}} onSubmit={this.addUser.bind(this)}  method="post">
                            <input style={{marginBottom: 10, fontSize: 16}} ref={"login"} placeholder="Логин" autoComplete='off' required/>
                            <input style={{marginBottom: 10, fontSize: 16}} ref={"userName"} type="text" placeholder="Имя" required/>
                            <input style={{marginBottom: 10, fontSize: 16}} ref={"password"} type="text" placeholder="Пароль" defaultValue={this.state.password} required autoComplete="off" minLength={6}/>
                            <select style={{marginBottom: 10, fontSize: 16}} ref={"type"} required>
                                {typeOptions}
                            </select>
                            <div style={{marginTop: 10, display: 'flex', justifyContent: 'space-between'}}>
                            <button style={{width: '45%', marginRight: 10, fontSize: 17}}>Готово</button>
                            <button style={{width: '45%', fontSize: 17}} onClick={this.closeModal.bind(this)}>Отмена</button>
                            </div>
                        </form>
                    </Modal>
                <Modal
                    isOpen={this.state.changeGroupModalIsOpen}
                    onRequestClose={this.closeModal.bind(this)}
                    style={customStyles}
                    ariaHideApp={false}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Назначить группы">
                    {this.state.groupAccessItems}
                    <div style={{marginTop: 10, display: 'flex', justifyContent: 'space-between'}}>
                        <button style={{width: '50%', marginRight: 10, fontSize: 17}} onClick={this.changeGroupAccess.bind(this)}>Готово</button>
                        <button style={{width: '50%', fontSize: 17}} onClick={this.closeModal.bind(this)}>Отмена</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.linkModalIsOpen}
                    onRequestClose={this.closeModal.bind(this)}
                    style={customStyles}
                    ariaHideApp={false}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Ссылка">
                    <div style={{width: '98%', display: 'flex', flexDirection: 'row', marginBottom: 10}}>
                        <textarea ref={'referenceTextArea'} readOnly={true} value={this.state.link} style={{marginRight: 5, height: 60}}/>
                        <img src={require('../../images/copy_content.png')} style={{ cursor: 'pointer', width: 30, height: 30, marginTop: 30}} onClick={this.copyContent.bind(this)}/>
                    </div>
                    <button style={{width: '100%', fontSize: 17}} onClick={this.closeModal.bind(this)}>Закрыть</button>
                </Modal>
                <UserGrid
                    ref={'grid'}
                    users={this.props.users}
                    groupNameList={this.props.groupNameList}
                    userTypeList={this.props.userTypeList}
                    typeMap={this.props.typeMap}
                    changeUserName={this.props.changeUserName}
                    removeUser={this.props.removeUser}
                    openChangeGroupAccess={this.openChangeGroupAccess.bind(this)}
                    openNewUserModal={this.openNewUserModal.bind(this)}
                    openNewLinkModal={this.openNewLinkModal.bind(this)}
                    setError={this.props.setError}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/UserGridContainer.js